import { OnlyViewHoc } from 'hocs'
import * as React from 'react'

import { AppButton } from 'components/AppButton'
import { AppModalHeader } from 'components/AppModal/AppModalHeader'
import { TextArea } from 'components/TextArea'

import { NonResidentObject, NonResidentStatus } from 'models/nonresident'

import { DocumentsList } from 'shared/ui'

import styles from './NonResidentDetails.module.scss'

interface Props {
  application: NonResidentObject
  disabled: boolean
  onAccept(): void
  onRework(controllerComment: string): void
  onRefuse(): void
  onClose?(): void
  openLivePhoto(): void
  openAttachments(index: number): void
  setLightbox(index: Array<string>): void
  attachments: string[]
}

export const NonResidentDetails: React.FC<Props> = ({
  application,
  disabled,
  attachments,
  onRework,
  onAccept,
  onClose,
  openAttachments,
  setLightbox,
}) => {
  const [controllerComment, setControllerComment] = React.useState(
    application.controller_comment || '',
  )
  function onDowloadPhotos() {
    const fullName = `${application.name}_${application.surname}`

    if (application.client_photo)
      downloadImage(application.client_photo, `${fullName}_клиент`)
    if (application.notarized_passport)
      downloadImage(
        application.notarized_passport,
        `${fullName}_паспрот_лицевая`,
      )
    if (application.notarized_passport_back)
      downloadImage(
        application.notarized_passport_back,
        `${fullName}_паспрот_задняя`,
      )
    if (application.passport)
      downloadImage(
        application.passport,
        `${fullName}_паспорт`,
      )
    if (application.stay_document)
      downloadImage(
        application.stay_document,
        `${fullName}_документ_по_проживанию`,
      )
  }

  return (
    <>
      <div className={styles.container}>
        <AppModalHeader onClose={onClose} title={`Заявка #${application.id}`} />
        <div className={styles.content}>
          <div className={styles.item}>
            <div className={styles.itemName}>Фамилия</div>
            <div className={styles.itemText}>{application.surname || '-'}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.itemName}>Имя</div>
            <div className={styles.itemText}>{application.name || '-'}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.itemName}>Отчество</div>
            <div className={styles.itemText}>
              {application.middle_name || '-'}
            </div>
          </div>

          <div className={styles.item}>
            <div className={styles.itemName}>ФИО в АБС</div>
            <div className={styles.itemText}>{application.name || '-'}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.itemName}>ИНН</div>
            <div className={styles.itemText}>{application.inn || '-'}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.itemName}>Банковская карта</div>
            <div className={styles.cardContainer}>
              <div className={styles.card}>{application.card?.type}</div>
              <span>{application?.card?.number}</span>
            </div>
          </div>

          {attachments.length ? (
            <div className={styles.item}>
              <div className={styles.itemName}>Фото документов</div>
              <div className={styles.photos}>
                {attachments.map((item, index) => {
                  return (
                    <div
                      key={item}
                      onClick={() => openAttachments(index)}
                      className={styles.itemPhoto}
                    >
                      <img src={item} alt="" />
                    </div>
                  )
                })}
              </div>
            </div>
          ) : null}

          <AppButton onClick={onDowloadPhotos} size="small" variant="siren">
            Скачать
          </AppButton>

          <OnlyViewHoc>
            {[
              NonResidentStatus.INITED,
              NonResidentStatus.CONSIDERATION,
            ].includes(application.status) && (
              <AppButton
                disabled={disabled}
                onClick={() => onRework(controllerComment)}
                size="small"
                variant="yellow"
              >
                На доработку
              </AppButton>
            )}

            {[NonResidentStatus.CONSIDERATION].includes(application.status) ? (
              <>
                <div className={styles.buttons}>
                  <AppButton
                    disabled={disabled}
                    onClick={onAccept}
                    size="small"
                    variant="siren"
                  >
                    Принять
                  </AppButton>
                </div>
                <TextArea
                  rows={4}
                  placeholder="Комментарий"
                  value={controllerComment}
                  onChange={e => {
                    const rawValue = e.currentTarget.value
                    setControllerComment(rawValue.slice(0, 3000))
                  }}
                />
              </>
            ) : null}
          </OnlyViewHoc>

          <DocumentsList list={application.anketa_photos} />
        </div>
      </div>
    </>
  )
}

async function downloadImage(
  imageSrc: string,
  imageName: string = 'imageName',
) {
  const image = await fetch(imageSrc)
  const imageBlog = await image.blob()
  const imageURL = URL.createObjectURL(imageBlog)

  const link = document.createElement('a')
  link.href = imageURL
  link.download = imageName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
